export const LatestBrowserVersions = {
    'chrome': 60,
    'firefox': 55,
    'opera': 47,
    'safari': 11,
    'ms-edge': 15,
    'IE': 11
};